import { PlateDesignParamType } from '@/common/queries/selections/plateDesign/plateDesign.type';
import { getPlateDesignFunction } from '@/common/queries/selections/plateDesign/plateDesignFunction';
import { queryOptions } from '@tanstack/react-query';

export const getPlateDesignOption = (param: PlateDesignParamType) =>
  queryOptions({
    queryKey: ['get_vehicle_plate-design', param],
    queryFn: () => getPlateDesignFunction(param),
  });
